import { render, staticRenderFns } from "./whatsapp-outbox.vue?vue&type=template&id=1b12ff08"
import script from "./whatsapp-outbox.vue?vue&type=script&lang=js"
export * from "./whatsapp-outbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports